import React from 'react';

const RocketchatContext = React.createContext(null);

export default RocketchatContext;
